import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Equipe} from '../models/equipe';


const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
const apiUrl = '/api/v1/equipes';

@Injectable()
export class EquipesService {

  constructor(private http: HttpClient) { }

  findByPage(p: number, size: number): Observable<any> {
    const params = new HttpParams()
      .set('page', String(p)).set('pageSize', String(size));
    const url = `${apiUrl}/findByPage`;
    return this.http.get<any>(url, {params});
  }

  getById(id: number) {
    const url = `${apiUrl}/${id}`;
    return this.http.get<any>(url);
  }

  delete(id: number) {
    const url = `${apiUrl}/${id}`;
    return this.http.delete<any>(url, httpOptions);
  }

  create(equipe: Equipe) {
    return this.http.post<Equipe>(apiUrl + '/save', equipe, httpOptions);
  }

  update(id, equipe: Equipe) {
    const url = `${apiUrl}/${id}`;
    return this.http.post(apiUrl + '/save', equipe, httpOptions);
  }

  findByIds(ids: number[]): Observable<any> {
    const params = new HttpParams()
        .set('ids', String(ids));
    const url = `${apiUrl}/findByIds`;
    return this.http.get<any>(url,{params});
  }

}
